export default __webpack_public_path__ + "static/media/PinkFrame06.c5fd2e1d.png";